import xihoumen from "./index.vue";
import xihoumenHome from "./Home.vue";

const emptyComponent = () => import("./emptyRouterComponent.vue");
const simpleCurrentData = () => import("./../../components/SimpleCurrentData.vue");
const errorRecord = ()=>import("./../../components/ErrorRecordControl.vue");
const dataHistory = () => import("./../../components/DataHistory.vue");
const login = () => import("./login.vue");
const gasClampUpstream = () => import("./gasClampUpstream.vue");
const gasClampDownstream = () => import("./gasClampDownstream.vue");
const valveClampUpstream = () => import("./valveClampUpstream.vue");
const valveClampDownstream = () => import("./valveClampDownstream.vue");
const cableClamp = () => import("./cableClamp.vue")
const stationMain = () => import("./stationMain.vue")
const stationBack = () => import("./stationBack.vue")
const stationVent = () => import("./stationVent.vue")
const stationVentBack = () => import("./stationVentBack.vue")


export default [
  {
    path: "/xihoumenIndex",
    name: "xihoumenIndex",
    component: xihoumenHome
  },
  {
    path: "/xihoumen/login",
    name: "xihoumenLogin",
    component: login
  },

  {
    path: "/xihoumen",
    name: "xihoumen",
    redirect: "/xihoumen",
    component: xihoumen,
    children: [
      {
        path: "currentDataTable",
        name: "currentDataTable",
        component: simpleCurrentData,
      },
      {
        path: "errorRecord",
        name: "errorRecord",
        component: errorRecord,
      },
      {
        path: "dataHistory",
        name: "dataHistory",
        component: dataHistory
      },
      {
        path: "cableClamp",
        name: "cableClamp",
        component: cableClamp
      },
      {
        path: "station",
        name: "station",
        redirect: "/xihoumen/station/main1",
        component: emptyComponent,
        children: [
          {
            path: "main1",
            name: "main1",
            component: stationMain
          },
          {
            path: "backup1",
            name: "backup1",
            component: stationBack
          },
          {
            path: "vent1",
            name: "vent1",
            component: stationVent
          },
          {
            path: "ventBackup1",
            name: "ventBackup1",
            component: stationVentBack
          },
          {
            path: "main2",
            name: "main2",
            component: stationMain
          },
          {
            path: "backup2",
            name: "backup2",
            component: stationBack
          },
          {
            path: "vent2",
            name: "vent2",
            component: stationVent
          },
          {
            path: "ventBackup2",
            name: "ventBackup2",
            component: stationVentBack
          },
        ],
      },
      {
        path: "gasClamp",
        name: "gasClamp",
        redirect: "/xihoumen/gasClamp/upstream",
        component: emptyComponent,
        children: [
          {
            path: "upstream",
            name: "upstream",
            component: gasClampUpstream
          },
          {
            path: "downstream",
            name: "downstream",
            component: gasClampDownstream
          },
        ],
      },
      // {
      //   path: "valveClamp",
      //   name: "valveClamp",
      //   redirect: "/xihoumen/valveClamp/upstream",
      //   component: emptyComponent,
      //   children: [
      //     {
      //       path: "upstream",
      //       name: "upstream",
      //       component: valveClampUpstream
      //     },
      //     {
      //       path: "downstream",
      //       name: "downstream",
      //       component: valveClampDownstream
      //     },
      //   ],
      // },
    ]
  }
];
